import React from 'react';

export default function NotFound() {
    return <span>NO SE HA ENCONTRADO LA PÁGINA</span>
}